import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type ShoreUserTitleRequest = CommonTableRequest;

export interface ShoreUserTitle {
    id: number;
    title: string | null;
    code: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface ShoreUserTitleResponse {
    data: ShoreUserTitle[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateShoreUserTitleRequest {
    title: string;
    code: string;
}

export type UpdateShoreUserTitleRequest = CreateShoreUserTitleRequest;

export const getApiShoreUserTitle = (
    clientId: number,
    tenantAlias: string,
    payload: ShoreUserTitleRequest,
): Promise<ShoreUserTitleResponse> =>
    httpApi
        .post<ShoreUserTitleResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-user-titles/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiShoreUserTitle = (
    clientId: number,
    tenantAlias: string,
    payload: CreateShoreUserTitleRequest,
): Promise<ShoreUserTitle> =>
    httpApi
        .post<ShoreUserTitle>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-user-titles`, payload)
        .then(({ data }) => data);

export const updateApiShoreUserTitle = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateShoreUserTitleRequest,
): Promise<ShoreUserTitle> =>
    httpApi
        .put<ShoreUserTitle>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-user-titles/${id}`, payload)
        .then(({ data }) => data);

export const deleteApiShoreUserTitle = (clientId: number, tenantAlias: string, id: number): Promise<ShoreUserTitle> =>
    httpApi
        .delete<ShoreUserTitle>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/shore-user-titles/${id}`)
        .then(({ data }) => data);
